/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.inbox.Criticality
*/
export var Criticality;
(function (Criticality) {
    Criticality["LOW"] = "LOW";
    Criticality["NORMAL"] = "NORMAL";
    Criticality["CRITICAL"] = "CRITICAL";
})(Criticality || (Criticality = {}));
//# sourceMappingURL=Criticality.js.map